import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { merchantInfoService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

type IsDailyDiscountFieldMutationProps = {
	id: number;
	value: boolean;
	onSuccessHandler?: Function;
};

const useIsDailyDiscountFieldMutation = () => {
	const dispatch = useDispatch();

	return useMutation(
		({ id, value }: IsDailyDiscountFieldMutationProps) => {
			return merchantInfoService.editIsDailyDiscount(id, value);
		},
		{
			onSuccess(data, { onSuccessHandler }) {
				onSuccessHandler?.();
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useIsDailyDiscountFieldMutation;
